import { Controller } from "stimulus"

/**
 * テーブル一覧／注文一覧のコントローラー
 */
export default class extends Controller {
  static targets = ["checkbox", "submitButton"];

  connect() {
    this.toggleSubmit();
  }

  /**
   * 「完了する」ボタンの有効・無効を切り替える
   */
  toggleSubmit() {
    const checkedCheckboxes = this.checkboxTargets.filter(checkbox => checkbox.checked);
    this.submitButtonTarget.disabled = checkedCheckboxes.length === 0;
  }

  /**
   * 注文した商品一覧部のチェックボックスの変更イベントハンドラ
   */
  checkboxChanged(event) {
    this.toggleSubmit();
  }

  /**
   * 「完了する」ボタン押下
   */
  submit(event) {
    const checkboxIds = this.checkboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.defaultValue);
    const seatGroupId = event.target.getAttribute('data-seat-group-id');

    $.ajax({
      url: `seat_groups/${seatGroupId}/update_item_delivered`,
      type: 'POST',
      dataType: 'script',
      data: {
        ids: checkboxIds
      },
      success: (data) => {
        // NOP
        // MEMO: フラッシュメッセージ表示などは refresh_seat_group_card.js.erb で行う
      },
      error: (xhr, status, error) => {
        const message = JSON.parse(xhr.responseText).message || 'エラーが発生しました'
        window.CommonUiUtil.showFlashMessage("seat-group-flash-block", [message], "error");
      }
    });
  }
}
